var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdfLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2047_10534)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.56277 14.5515H5.56152V16.0448H6.56277C6.96477 16.0448 7.28277 15.6908 7.28277 15.3188C7.28202 14.8995 6.96477 14.5515 6.56277 14.5515Z",
    fill: "url(#paint0_linear_2047_10534)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5919 14.5815H9.59668V17.268H10.5919C12.2112 17.268 12.2824 14.5815 10.5919 14.5815Z",
    fill: "url(#paint1_linear_2047_10534)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.75 11.25H2.25C1.8375 11.25 1.5 11.5875 1.5 12V19.5C1.5 19.9125 1.8375 20.25 2.25 20.25H18.75C19.1632 20.25 19.5 19.9125 19.5 19.5V12C19.5 11.5875 19.1632 11.25 18.75 11.25ZM6.5625 16.7947H5.56125V17.5867C5.56125 17.8507 5.39325 18 5.17725 18C4.97925 18 4.77 17.8507 4.77 17.586V14.2103C4.77 14.0123 4.926 13.7955 5.17725 13.7955H6.5625C7.3425 13.7955 8.0445 14.3175 8.0445 15.3187C8.04375 16.2667 7.3425 16.7947 6.5625 16.7947ZM10.6462 18H9.219C9.021 18 8.805 17.8912 8.805 17.628V14.2222C8.805 14.0062 9.021 13.8502 9.219 13.8502H10.5922C13.3328 13.8502 13.2727 18 10.6462 18ZM15.99 14.6295H14.244V15.5828H15.7733C15.99 15.5828 16.2052 15.7987 16.2052 16.0087C16.2052 16.2067 15.99 16.368 15.7733 16.368H14.244V17.6273C14.244 17.8373 14.0948 17.9993 13.8848 17.9993C13.6208 17.9993 13.4587 17.8373 13.4587 17.6273V14.2215C13.4587 14.0055 13.6215 13.8495 13.8848 13.8495H15.99C16.254 13.8495 16.4093 14.0055 16.4093 14.2215C16.4093 14.4142 16.254 14.6295 15.99 14.6295Z",
    fill: "url(#paint2_linear_2047_10534)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.75 5.6895L16.8105 0.75C16.377 0.315 15.615 0 15 0H6.75C5.5095 0 4.5 1.0095 4.5 2.25V9.75C4.5 10.1648 4.83525 10.5 5.25 10.5C5.66475 10.5 6 10.1648 6 9.75V2.25C6 1.83675 6.336 1.5 6.75 1.5H13.5C14.3287 1.5 15 2.172 15 3V5.8125C15 6.741 15.7605 7.5 16.6875 7.5H19.5C20.3287 7.5 21 8.172 21 9V21.75C21 22.1632 20.6647 22.5 20.25 22.5H6.75C6.336 22.5 6 22.1632 6 21.75C6 21.3353 5.66475 21 5.25 21C4.83525 21 4.5 21.3353 4.5 21.75C4.5 22.9905 5.5095 24 6.75 24H20.25C21.4905 24 22.5 22.9905 22.5 21.75V7.5C22.5 6.88575 22.185 6.12375 21.75 5.6895Z",
    fill: "url(#paint3_linear_2047_10534)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2047_10534",
    x1: 5.56152,
    y1: 15.3033,
    x2: 7.28277,
    y2: 15.3033,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#934247"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD4A50"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2047_10534",
    x1: 9.59668,
    y1: 15.934,
    x2: 11.8332,
    y2: 15.934,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#934247"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD4A50"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2047_10534",
    x1: 1.5,
    y1: 15.781,
    x2: 19.5,
    y2: 15.781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#934247"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD4A50"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2047_10534",
    x1: 4.5,
    y1: 12.0828,
    x2: 22.5,
    y2: 12.0828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#934247"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD4A50"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2047_10534"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfLogo);
export default __webpack_public_path__ + "static/media/pdf-logo.172587f00cca09770ad7e73746828b2d.svg";
export { ForwardRef as ReactComponent };